"use client";
import React, { useEffect, useState, useCallback } from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid'
import Cookies from 'js-cookie';

export default function Banners() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    try {
      const dismissed = Cookies.get('banner_demo_dismissed');
      if (dismissed === '1') {
        setVisible(false);
      }
    } catch (e) {
      // ignore cookies read errors
    }
  }, []);

  const handleDismiss = useCallback(() => {
    try {
      Cookies.set('banner_demo_dismissed', '1', { expires: 365, path: '/' });
    } catch (e) {
      // ignore cookies write errors
    }
    setVisible(false);
  }, []);

  if (!visible) return null;
  return (
    <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 dark:bg-gray-800/50 dark:after:pointer-events-none dark:after:absolute dark:after:inset-x-0 dark:after:bottom-0 dark:after:h-px dark:after:bg-white/10">
      <div
        aria-hidden="true"
        className="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl"
      >
        <div
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
          className="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30 dark:opacity-40"
        />
      </div>
      <div
        aria-hidden="true"
        className="absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl"
      >
        <div
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
          className="aspect-577/310 w-144.25 bg-linear-to-r from-[#ff80b5] to-[#9089fc] opacity-30 dark:opacity-40"
        />
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <p className="text-sm/6 text-gray-900 dark:text-gray-100">
          <strong className="font-semibold">Демо-сайт</strong>
          <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
            <circle r={1} cx={1} cy={1} />
          </svg>
          Этот ресурс предназначен только для демонстрации. Весь контент носит исключительно информационный характер и не является офертой.
        </p>
      </div>
      <div className="flex flex-1 justify-end">
        <button type="button" className="-m-3 p-3 focus-visible:-outline-offset-4" onClick={handleDismiss}>
          <span className="sr-only">Закрыть уведомление</span>
          <XMarkIcon aria-hidden="true" className="size-5 text-gray-900 dark:text-gray-100" />
        </button>
      </div>
    </div>
  )
}


